module.exports = __webpack_public_path__ + "img/Path 844-2.03665c7d.svg";